import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Forbidden from "pages/errors/Unauthorized";
import MainLayout from "layouts/main";
import AuthLayout from "layouts/auth";
import RecruitmentTestLayout from "layouts/recruitment_test";
import ClientSetupPassword from "pages/client_portal/ClientSetupPassword";

import RequireAuth from "./RequireAuth";
import  { userRoutes, authRoutes, clientRoutes } from "routes";
import { filterRoutesByPermissions } from 'utils/utilityFunctions'

import { usePermissions, useIsClientUser } from "app/hooks";
import NotFound from "pages/errors/NotFound";
import { NotificationProvider } from "context/NotificationContext";
import ClientPortalLayout from "layouts/client_portal";

const App = () => {
  const permissions = usePermissions();
  const isClientUser = useIsClientUser();
  
  const [userRoutesByPermissions, setUserRoutesByPermissions] = useState<RoutesType[]>(filterRoutesByPermissions(userRoutes, permissions));
  const [clientRoutesByPermissions, setClientRoutesByPermissions] = useState<RoutesType[]>(filterRoutesByPermissions(clientRoutes, permissions, true));
  
  useEffect(()=> {
    setUserRoutesByPermissions(filterRoutesByPermissions(userRoutes, permissions));
    setClientRoutesByPermissions(filterRoutesByPermissions(clientRoutes, permissions, true));
    console.log("Permission Changed Now:");
    
  }, [permissions]);
  // Filter out conflicting routes based on user type
  // If user is client, remove /leaves from userRoutes (they use clientRoutes)
  // If user is NOT client, remove /leaves from clientRoutes (they use userRoutes)
  const filteredUserRoutes = isClientUser 
    ? userRoutesByPermissions.filter(route => route.path !== "/leaves")
    : userRoutesByPermissions;
  
  const filteredClientRoutes = !isClientUser
    ? clientRoutesByPermissions.filter(route => route.path !== "/leaves")
    : clientRoutesByPermissions;
  
  // Separate routes by layout
  const mainRoutes = filteredUserRoutes.filter(
    route => route.layout === "Main" || !route.layout
  );
  
  const testRoutes = userRoutes.filter(
    route => route.layout === "RecruitmentTest"
  );

  return (
    <NotificationProvider>
      <Routes>
        <Route path="/forbidden" element={<Forbidden />} />
        {/* Public routes - no authentication required */}
        <Route path="/client-setup/:token" element={<ClientSetupPassword />} />
        <Route element={<AuthLayout />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.component} key={idx} />
          ))}
        </Route>
        {/* Recruitment Test Routes (No Sidebar/Navbar) */}
        <Route element={<RecruitmentTestLayout />}>
          {testRoutes.map((route, idx) => (
            <Route 
              path={route.path} 
              element={route.component}
              key={`test-${idx}`}
            />
          ))}
        </Route>

        {/* Client Portal Routes */}
        <Route element={<ClientPortalLayout />}>
          {filteredClientRoutes.map((route, idx) => (
            <Route 
              path={route.path} 
              element={
                <RequireAuth allowedPermissions={route.permissions?? []} title={route.name || "Client Portal"} >
                  {route.component}
                </RequireAuth>
              }
              key={`client-${idx}`}
            />
          ))}
        </Route>

        {/* Main Routes */}
        <Route element={<MainLayout />}>         
          {filteredUserRoutes.map((route, idx) => (
            <Route 
              path={route.path} 
              element={
                <RequireAuth allowedPermissions={route.permissions?? []} title={route.name || "Main"} >
                  {route.component}
                </RequireAuth>
              }
              key={idx}
            />
          ))}
        </Route>
        <Route path="/not-found" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </NotificationProvider>
  );
};

export default App;
